import React, { useState } from 'react';
import useStyle from './tableMyResultCarousel.style';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { classNames } from 'helpers/style/classNames';
import { SubTitle } from 'components/atoms/Texts/SubTitle';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';
import { contentsDataProps } from 'components/organisms/Table/TableMyResult/TableMyResult.view';
import { TableMyResultCarouselText } from 'components/atoms/Texts/TableMyResultCarouselText';

export interface TableMyResultCarouselProps {
  contentsData: contentsDataProps;
  subtitle?: string;
}

export const TableMyResultCarousel = ({
  contentsData,
  subtitle
}: TableMyResultCarouselProps) => {
  const classes = useStyle();
  const [position, setPosition] = useState(1);
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      slideChanged() {
        setPosition(instanceRef.current.track.details.rel + 1);
      }
    },
    []
  );

  return (
    <div className={classes.container}>
      {subtitle && <SubTitle text={subtitle} />}
      <div
        ref={sliderRef}
        className={classNames(['keen-slider', classes.root])}
      >
        {contentsData.legends.map((legend, key) => (
          <div key={key} className="keen-slider__slide">
            <TableMyResultCarouselText
              name={legend}
              value={contentsData.me[key + 1]}
              classValue={contentsData.myClass[key + 1]}
            />
          </div>
        ))}
      </div>
      <div className={classes.footer}>
        <FlatIcon icon={'DoubleArrowVertical'} />
        <span>
          {position} / {contentsData.legends.length}
        </span>
      </div>
    </div>
  );
};
